export const trackError = error => {
  if (!localStorage.errors) {
    localStorage.errors = JSON.stringify([])
  }

  const errors = JSON.parse(localStorage.errors)
  errors.push(error)
  localStorage.errors = JSON.stringify(errors)
}

export const getErrors = () => {
  return localStorage.errors ? JSON.parse(localStorage.errors) : []
}

export const clearErrors = () => {
  localStorage.removeItem('errors')
}
